module.exports = __webpack_public_path__ + "img/location.2206382b.png";